<template>
  <div class="flex flex-col">
    <p class="font-semibold mb-1">{{ $t('pages.shop.checkout.tab1.coupom') }}</p>
    <div class="flex flex-col justify-between">
      <div class="relative w-full shadown focus:shadow-2xl">
        <vs-input class="w-full" :class="{'border border-primary rounded-lg': validCoupom}"
                  :placeholder="$t('pages.shop.checkout.tab1.typeCoupom')" @blur="searchForCoupom" @keyup.enter="searchForCoupom"
                  v-model="searchCoupom" />

        <div class="absolute top-0 right-0 p-2" v-if="!getCoupom">
          <feather-icon icon="SearchIcon" svgClasses="h-6 w-6 cursor-pointer" @click.stop="searchForCoupom"/>
        </div>

        <div class="absolute top-0 right-0 p-2" v-else>
          <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click.stop="clearCoupom" />
        </div>
      </div>

      <div v-if="coupomError">
        <span class="text-sm text-danger">
          {{ coupomError }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CoupomService from "@/services/Coupom.service";

export default {
  name: "CheckoutCoupom",
  data() {
    return {
      searchCoupom: null,
      coupomError: null,
    }
  },
  computed: {
    validCoupom() {
      if (this.getCoupom) {
        return true;
      } else {
        return false;
      }
    },
    getCoupom() {
      return this.$store.state.Shop.getCoupom();
    },
  },
  methods: {
    searchForCoupom() {
      this._.debounce((vm) => {
        if (!vm.searchCoupom) {
          return;
        }

        vm.coupomError = null;
        CoupomService.lookupCoupom(vm.searchCoupom).then((response) => {
          vm.$store.dispatch('Shop/setCartCoupom', response).then((coupom) => {
            vm.searchCoupom = coupom.name.toUpperCase();
          });
        }, (error) => {
          vm.searchCoupom = null;
          vm.coupomError = error.message;
        });
      }, 300)(this);
    },
    clearCoupom() {
      this.searchCoupom = null;
      this.$store.commit('Shop/SET_CART_COUPOM', null);
    },
  },
  mounted() {
    if (this.getCoupom) {
      this.searchCoupom = this.getCoupom.name;
    }
  }
}
</script>

<style scoped>

</style>
